"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,16.8c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3C16.8,14.9,14.9,16.8,12.5,16.8z M12.5,9.2 c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3S14.3,9.2,12.5,9.2z"
  }));
};

exports["default"] = _default;